import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { black1, green } from 'app/components/ThemeProvider/colors';

const ManatIcon = ({ sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon viewBox="0 0 20 20" sx={{ height: '20px', width: '20px', fill: 'transparent', ...sx }} {...props}>
      <path
        d="M8.95013 17V7.43333C6.2668 8.01667 3.8168 10.1167 3.8168 15.8333V17H1.7168V15.8333C1.7168 8.71667 4.98346 6.26667 8.95013 5.33333V3H11.0501V5.33333C15.0168 6.26667 18.2835 8.71667 18.2835 15.8333V17H16.1835V15.8333C16.1835 10.1167 13.7335 8.01667 11.0501 7.43333V17H8.95013Z"
        fill={props.color === 'warning' ? green : black1}
        stroke="1.5"
      />
    </SvgIcon>
  );
};

export default ManatIcon;
